import { render, staticRenderFns } from "./fans.vue?vue&type=template&id=61650cf1&scoped=true"
import script from "./fans.vue?vue&type=script&lang=js"
export * from "./fans.vue?vue&type=script&lang=js"
import style0 from "./fans.vue?vue&type=style&index=0&id=61650cf1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61650cf1",
  null
  
)

export default component.exports